import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Resolve, Router, RouterStateSnapshot, RouterLink } from '@angular/router';
import { PatientService, UserService } from '../shared';
import { environment } from '../shared/config/app-config';
import { Subscription } from 'rxjs/Subscription';
import { JwtService, User } from '../shared';
@Component({
  templateUrl: 'patientonboard.component.html',
  styleUrls: ['./style.component.css']

})

export class PatientonboardComponent implements OnInit, OnDestroy {
  // imageURL: string;
  public data: Object;
  imagelogo
  apiurl = environment.api_url;
  params: any;
  currentUser: User
  patimage: any = {};
  subscription: Subscription;
  constructor(
    private router: ActivatedRoute,
    private patientservice: PatientService,
    private userService: UserService,
    private jwtService: JwtService
  ) { }
  ngOnInit() {
    this.subscription = this.patientservice.navItem$
      .subscribe(item => {
        this.gwtImage(item)
      }
      )
    this.router.params.subscribe(params => {
      this.params = params


    });
    //////console.log(this.route.snapshot.url[0].path);
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;

      }
    )
    //   if(this.currentUser.item.hostModel=="CLOUD")
    //   this.imageURL = environment.cloudeImageURL;
    // else     
    //   this.imageURL = environment.vmImageURL;

    // if(this.router.snapshot.url[0].path == 'recovery'){
    //   this.currentUser.status = true
    // }

  }

  gwtImage(id) {
    if (window.localStorage['status'] == 'forgotlink') {
      if (window.localStorage['mail']) {
        this.userService.forgotUserInfo(window.localStorage['mail'])
          .subscribe(
            data => {
              if (data) {
                this.jwtService.saveclientlogo(data.clientLogoPath);
                this.patimage = window.localStorage['logopath']
              }
            })

      }
    }
    else {
      this.patientservice
        .getwelcomepat(id)
        .subscribe(
          data => {
            //////console.log(this.params);
            this.jwtService.saveclientlogo(data.clientLogoPath);
            this.patimage = window.localStorage['logopath']
            //////console.log(this.patimage)
          }
        );
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }


  getFullYear() {
    return new Date().getFullYear();
  }
}






